import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './Sidebar.css';

export interface Props extends FlexProps {
  theme?: 'dark' | 'light';
}

/**
 * A full sidebar navigation component that can include a combination
 * of top level and sub menus.
 */
const Sidebar: React.FunctionComponent<Props> = (props: Props) => {
  const { theme, ...rest } = props;
  const classes = classnames('Sidebar', `Sidebar--theme-${theme}`);

  return (
    <Flex className={ classes } grow { ...rest } />
  );
};

Sidebar.defaultProps = {
  theme: 'dark',
};

export default Sidebar;
